import React, {CSSProperties, ReactNode} from 'react'
import './styles.css'

interface TopButtonsWrapperProps {
    leftButtons?: ReactNode,
    rightButtons: ReactNode,
    style?: CSSProperties

}

const TopButtonsWrapper = ({leftButtons, rightButtons, style}: TopButtonsWrapperProps) => {
    return <section style={style} className={"top-buttons-wrapper-container"}>
        <div className={'top-buttons-wrapper-left-buttons'}>
            {leftButtons}
        </div>
        <div className={'top-buttons-wrapper-right-buttons'}>
            {rightButtons}
        </div>
    </section>
}

export default TopButtonsWrapper